// Helpers compartidos por los modulos de la guia didactica.
//
// Permiten ocultar un modulo (o un campo suelto) cuando NO tiene contenido real,
// en vez de mostrar textos de relleno ("Titulo no disponible", "Sin descripcion")
// o el "Error al cargar el modulo" del catch. Si un modulo no tiene datos, no se
// renderiza: la guia queda limpia.

// String normal con texto util.
export function hasText(value) {
  return typeof value === "string" && value.trim().length > 0;
}

// HTML de TipTap: descarta tags vacios (<p></p>, &nbsp;, saltos) que no son
// contenido real.
export function htmlHasContent(html) {
  if (typeof html !== "string") return false;
  return (
    html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim().length > 0
  );
}

// Array con al menos un elemento.
export function hasItems(arr) {
  return Array.isArray(arr) && arr.length > 0;
}
